import { Controller } from "@hotwired/stimulus"

// Rotates a chevron icon when a Bootstrap collapse target opens/closes.
//
// Usage:
//   <div data-controller="collapse-icon" data-collapse-icon-target-value="#someId">
//     <a href="#someId" data-bs-toggle="collapse">
//       Label
//       <i class="fa-regular fa-chevron-down" data-collapse-icon-target="icon"
//          style="transition: transform 0.2s ease;"></i>
//     </a>
//   </div>

export default class extends Controller {
  static targets = ["icon"]
  static values = { target: String }

  connect() {
    this.collapseEl = document.querySelector(this.targetValue)
    if (!this.collapseEl) return

    this._onShow = () => this.iconTarget.style.transform = "rotate(180deg)"
    this._onHide = () => this.iconTarget.style.transform = "rotate(0deg)"

    this.collapseEl.addEventListener("show.bs.collapse", this._onShow)
    this.collapseEl.addEventListener("hide.bs.collapse", this._onHide)
  }

  disconnect() {
    if (!this.collapseEl) return
    this.collapseEl.removeEventListener("show.bs.collapse", this._onShow)
    this.collapseEl.removeEventListener("hide.bs.collapse", this._onHide)
  }
}
